import React from 'react';
import FireWall from './FireWall';
import { useQuery } from 'react-query';
import Loading from 'components/common/loading';

const FireWallContainer = () => {
  const { data: vsFirewall, isLoading: firewallLoading, refetch } = useQuery('/vs/firewall');

  if (firewallLoading) {
    return <Loading gap={200} />;
  }
  return <FireWall vsFirewall={vsFirewall} refetch={refetch} />;
};

export default FireWallContainer;
